import _ from 'lodash';
import React from 'react';

import { useNetSuitePaymentMethodSelectFieldQuery } from 'generated/graphql';



export interface IPaymentMethod {
  id: string;
  name: string;
}

export interface IData {
  objects: IPaymentMethod[];
}

export function useQuery() {
  const tuple = useNetSuitePaymentMethodSelectFieldQuery({});

  const wrappedTuple = React.useMemo(() => {
    const data: IData = {
      objects: _.map(tuple.data?.netSuitePaymentMethods ?? [], (node): IPaymentMethod => ({
        id: node.id,
        name: `${node.name} (${node.internalId})`
      }))
    };

    return {
      loading: tuple.loading,
      data,
      refetch: async () => {
        tuple.refetch({});
      }
    };
  }, [tuple]);

  return wrappedTuple;
}
